<template>
  <div>

    <div style="display: flex; align-items: center">
      <div
        style="display: flex; align-items: center; margin: 10px 10px 10px 10px"
        v-if="$store.languages.length"
      >
        <span style="margin-right: 10px">Secondary Language:</span>
        <select v-model="$store.secondaryLanguageMT">
          <option v-if="$store.languages.length > 0" value disabled selected>
            Select Language
          </option>
          <option v-if="$store.languages.length == 0">
            No languages were found
          </option>
          <option
            v-for="(language, index) in $store.languages"
            :key="index"
            v-bind:value="language.id"
          >
            {{ language.name }}
          </option>
        </select>
      </div>
      <label style="margin-left: 20px">
        <input
          type="checkbox"
          class="filled-in"
          v-model="$store.inspectionViewMT"
        />
        <span>Inspection view</span>
      </label>
    </div>
    <div v-if="!instanceSelected">
      <div
        v-if="loading"
        style="
          width: 100%;
          height: 70vh;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <Spinner />
      </div>
      <div v-if="!loading">
        <InstanceSelector v-on:loadInstance="loadInstance" />
      </div>
    </div>
    <div v-else class="row missing-translation-container">
      <div class="col s12">
        <div class="card">
          <div
            v-if="$store.loggedInUser.username=='admin' && !loading"
            style="
              width: 100%;
              padding: 20px 0px;
              text-align: center;
              font-weight: 600;
            "
          >
            Dialogs Missing Translation:
            {{ $store.dialogsMissingTranslationCount }}
            &nbsp;&nbsp;&nbsp;
            Words Missing Translation:
            {{ countWords }}
          </div>
          <div v-if="$store.loggedInUser.username=='admin' && !loading" class="card"
            style="
              width: 20%;
              padding: 20px 0px;
              font-weight: 600;
              top: 10px; 
              right: 10px;
              position: absolute;
              background: #D3D3D3; 
            "
            >
              <div class="counter"
                style="
                padding: 5px 0px;
                font-weight: 700;
                font-size:11px;
                text-align:start;
                margin-bottom:10px;
                margin-left:10px;
              "
              >
              No:of phrases translated :
              &nbsp;&nbsp;
              {{this.totalDialogsMissingTranslation - $store.dialogsMissingTranslationCount }}
              </div>
              <div class="counter"
                style="
                padding: 5px 0px;
                font-weight: 700; 
                font-size:11px;
                text-align:start;
                margin-left:10px;
              "
              >
              Phrases Remaining
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; :
              &nbsp;&nbsp;
              {{ $store.dialogsMissingTranslationCount }}
            </div>
          </div>
          <div
            v-if="$store.loggedInUser.username=='admin' && !loading"
            style="
              width: 100%;
              padding: 20px 0px;
              text-align: center;
              font-weight: 600;
            "
          >
           Unique  Dialogs Missing Translation:
            {{ $store.uniqueArr.length}}
            &nbsp;&nbsp;&nbsp;
           Unique Words Missing Translation:
            {{ $store.uniqueWordsMissingTranslationCount }}
          </div>
          <div
            v-if="$store.loggedInUser.username!='admin' && !loading"
            style="
              width: 100%;
              padding: 20px 0px;
              text-align: center;
              font-weight: 600;
            "
          >
            Dialogs Missing Translation:
            {{ $store.uniquePhrasesMissingIds.length }}
            &nbsp;&nbsp;&nbsp;&nbsp;
            No: of phrases translated:
            {{$store.translatedPhraseIds.length }}
          </div>
          <div
            style="
              position: fixed;
              top: 5px;
              right: 20px;
              display: flex;
              flex-direction: row;
              align-items: center;
              z-index: 999;
              padding: 5px;
              border-radius: 2px;
              box-shadow: 1px 1px 3px #888;
              background: white;
            "
            v-if="!loading"
          >
            
            <span
              v-if="$store.dialogsMissingTranslationCount"
              style="
                display: flex;
                flex-direction: row;
                align-items: center;
                padding: 5px 10px;
                border-left: 1px solid #ebebeb;
              "
            >
              <span
                class="material-icons move-btn"
                @click="$store.move(-1)"
                style="margin-right: 10px"
                title="Move to previous"
                >keyboard_arrow_up</span
              >

              <span
                class="material-icons move-btn"
                @click="$store.move(1)"
                title="Move to next"
                >keyboard_arrow_down</span
              >
            </span>
            <span
              title="Move to top"
              class="material-icons move-btn"
              style="padding: 5px 10px; border-left: 1px solid #ebebeb;border-right: 1px solid #ebebeb"
              @click="moveToTop()"
              >vertical_align_top</span
            >
            <button
              class="btn"
              style="border:0px solid;border-radius:4px;margin-left:5px"
              @click="saveChanges()"
              :disabled="!$store.saveChangesMT"
              >Save Changes</button
            >
          </div>
          <ul v-show="!loading" class="browser-default dialog-tree-row">
            <MissingTranslationItem
              v-for="(dialog, index) in nextDialogs"
              :key="index"
              :dialog="dialog"
              :parentOpen="true"
              :itemNumber="''"
            />
          </ul>
          <div
            style="
              width: 100%;
              height: 70vh;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
            "
            v-if="loading"
          >
            <Spinner />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MissingTranslationItem from "../components/MissingTranslationItem";
import InstanceSelector from "../components/InstanceSelector";
import Spinner from "../components/Spinner";
export default {
  name: "missingtranslation",
  components: {
    MissingTranslationItem,
    InstanceSelector,
    Spinner,
  },
  data() {
    return {
      instances: [],
      instanceSelected: false,
      rootDialogID: "",
      instance: "",
      nextDialogs: {},
      loading: true,
      displaySecondaryLanguage: false,
      secondaryLanguage: "",
      phraseID: [],
      dataPackageAvailable: false,
      dataPackageVersion: -1,
      dataPackageDate: null,
      totalDialogsMissingTranslation: 0,
    };
  },
  updated() {
    M.FormSelect.init(document.querySelectorAll("select"), {});
  },
  mounted() {
    this.$store.saveChangesMT = false;
    M.FormSelect.init(document.querySelectorAll("select"), {});
    this.$store.dialogsMT = {};
    this.$store.phrasesMT = {};
    this.$store.instances = [];
    this.$store.checkTranslationPhrases = {};
    this.$store.dialogCounter = 0;
    this.$store.loadCount = 0;
    this.$store.lastPhraseUpdated = {};
    this.$store.secondaryLanguageMT = "";
    this.$store.inspectionViewMT = false;
    this.$http.get("dialogs?tag=start").then((r) => {
      r.data.forEach((i) => {
        var instance = {};
        instance.id = i.id;
        i.tags.forEach((tag) => {
          if (tag.includes("start_")) {
            var name = tag.split("start_")[1];
            instance.name = name;
          }
        });
        this.$store.instances.push(instance);
      });
      this.loading = false;
    });
  },
  watch: {
    "$store.loadCount": function (val) {
      if (val == 0) {
        this.$store.phrasesMT = {};
        this.initialiseState();
        this.$store.findIncompleteDialogs();
        localStorage.setItem('totalDialogsMissingTranslation',this.$store.dialogsMissingTranslationCount);
        this.totalDialogsMissingTranslation = localStorage.getItem('totalDialogsMissingTranslation');
        this.loading = false;
        this.moveToTop();
      }
    },
    "$store.preferredLanguage": function (val) {
      this.loading = true;
      this.initialiseState();
      this.$store.findIncompleteDialogs();
      localStorage.setItem('totalDialogsMissingTranslation',this.$store.dialogsMissingTranslationCount);
      this.totalDialogsMissingTranslation = localStorage.getItem('totalDialogsMissingTranslation');
      this.loading = false;
      this.moveToTop();
    },
  },
  methods: {
    saveChanges(){
      var msg = "Changes Queued. It will take around 10 minutes to reflect the changes";
      M.toast({ html: msg, classes:"green"});
      this.$store.saveChangesMT = false;
    },
    moveToTop() {
      window.scrollTo(0, 0);
    },
    loadInstance(instance) {
      this.$store.loadCount = 0;
      this.loading = true;
      instance = instance.split("@@");
      const dataVersion = instance[2];
      this.instance = instance[0];
      this.$store.instanceMT = this.instance;
      this.$http
        .get(
          "settings/datapackage?instance=start_" +
            instance[0] +
            "&version=" +
            dataVersion
        )
        .then(async (r) => {
          var phraseIDS = [];
          r.data.dialogs.forEach(dg => {
            if(phraseIDS.indexOf(dg.phrase) < 0) phraseIDS.push(dg.phrase);
            if(dg.tags && dg.tags.indexOf("start") >= 0){
              phraseIDS.pop();
            }
            if(dg.tags && dg.tags.indexOf("paragraph") >= 0){
              dg.tags.forEach(tag => {
                if(tag.includes("phrase_")){
                  var phraseID = tag.split("_")[1];
                  if(phraseID && phraseIDS.indexOf(phraseID) < 0) phraseIDS.push(phraseID);
                }
              })
            }
          })
          var p = [];
          while(phraseIDS.length != 0){
            var chunk = phraseIDS.splice(0, 200);
            if(chunk.length == 1) chunk.push(chunk[0]);
            chunk = chunk.join();
            p.push(this.getPhraseChunk(chunk));
          }
          await Promise.all(p);
          r.data.dialogs.forEach((d) => {
            if(d.order){
              d.order = [...new Set(d.order)]
            }
            
            if(d.tags && d.tags.indexOf("paragraph") >= 0){
              var nextParagraph = [];
              d.tags.forEach(tag => {
                if(tag.includes("phrase_")){
                  var p = tag.split("_");
                  if(this.$store.phrasesMT[p[1]]){
                    var di = {
                      id: d.id + p[3],
                      phrase: p[1],
                      order: [],
                      type: "instruction_paragraph",
                      tags: [],
                    }
                    this.$set(this.$store.dialogsMT, di.id, di);
                    nextParagraph.push(di.id);
                  }
                }
              })
              d.order = d.order ? d.order : [];
              nextParagraph.forEach(p => d.order.push(p));
            }

            var dialog = {
              id: d.id, 
              phrase: d.phrase,
              order: d.order, // next child id.
              type: d.type,
              tags: d.tags,
            };
            if(this.$store.phrasesMT[dialog.phrase] || (dialog.tags && dialog.tags.indexOf("start") >= 0)) this.$set(this.$store.dialogsMT, d.id, dialog);
          });
          for (var dID in this.$store.dialogsMT) {
            var dialog = this.$store.dialogsMT[dID];
            var indices = [];
            if (dialog.order)
              dialog.order.forEach((id, i) => {
                if (!this.$store.dialogsMT[id]) {
                  indices.push(i);
                }
              });
            indices = indices.reverse();
            if (indices.length > 0) {
              indices.forEach((i) => {
                dialog.order.splice(i, 1);
              });
            }
            this.$store.dialogsMT[dID] = dialog;
          }
          this.rootDialogID = instance[1];
          this.instanceSelected = true;
          var rootDialog = this.$store.dialogsMT[instance[1]];
          var dialog = {};
          dialog.tags = ["start"];
          dialog.phrase = "";
          dialog.id = this.rootDialogID;
          dialog.next = rootDialog.order;
          dialog.type = "";
          this.$store.loadCount += dialog.next.length;
          this.$set(this.nextDialogs, dialog.id, dialog);
        });
    },
    getPhraseChunk(chunk){
      return new Promise((resolve, reject) => {
        this.$http.get("/phrases/" + chunk).then(res => {
          res.data.forEach(p => {
              this.$set(this.$store.phrasesMT, p.id, p);
           })
           resolve();
        })
      });
    },
    
    initialiseState() {
      this.$store.currentIndexMT = -1;
      this.$store.dialogsMissingTranslationCount = 0;
      this.$store.wordsMissingTranslationCount = 0;
      this.$store.dialogsMissingTranslation = [];
      this.$store.translatedPhraseIds = [];
      var highlighted = document.querySelectorAll(".highlight") || [];
      var i;
      for (i = 0; i < highlighted.length; i++) {
        highlighted[i].classList.remove("highlight");
      }
    }
    

  },
  computed: {
    countWords() {
      if(this.$store.loggedInUser.username!='admin'){
        return 0;
      }
      this.$store.wordsMissingTranslationCount=0;
      this.$store.uniqueWordsMissingTranslationCount=0;

      var arr = [];
      var arrID = {};
      var dialogsMissingTranslation = [];
      for (var dID in this.$store.checkTranslationPhrases) {
        const phrase = this.$store.checkTranslationPhrases[dID];
        var foundTranslation = phrase.translations.filter(
          (t) => t.language === this.$store.preferredLanguage
        )[0];
        var secondaryTranslation = phrase.translations.filter(
          (t) => t.language === this.$store.secondaryLanguageMT
        )[0];
        if (
          secondaryTranslation && !foundTranslation
        ) {
          var uniqueW = false;
        if(!this.$store.uniqueArr.includes(phrase.id)){
          uniqueW=true
      }

      var count = secondaryTranslation.text.match(/\S+/g) ;
          if(uniqueW){
            this.$store.uniqueWordsMissingTranslationCount +=count?count.length:0;
           }        
        }
        if (
            !foundTranslation &&
             dialogsMissingTranslation.indexOf(dID) < 0
          ) {
            var arrayOfItemNumber = this.$store.dialogsItemNumber[dID];
            for(let i=0;i<arrayOfItemNumber.length;i++){
              const itemNumber = arrayOfItemNumber[i];
              arr.push(itemNumber);
              arrID[itemNumber] = dID;
              if(1==0){ continue;}
              var secondaryTranslation = phrase.translations.filter(
                  (t) => t.language === this.$store.secondaryLanguageMT
                )[0];
                if (secondaryTranslation && !foundTranslation) {
                  var count = secondaryTranslation.text.match(/\S+/g);
                  this.$store.wordsMissingTranslationCount +=count?count.length:0;
                }
            }
          }        
      }
    
   return this.$store.wordsMissingTranslationCount;
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.saveChangesMT) {
      M.toast({ html: "Save changes", classes: "red" });
    } else {
      next();
    }
  },
  created() {
    window.addEventListener("beforeunload", (e) => {
      if (this.$store.saveChangesMT) {
        e.preventDefault();
        e.returnValue = "please save changes";
      }
    });
  },
};
</script>

<style scoped>
.missing-translation-container{
  height: calc(100vh - 80px);
  margin-bottom: 0px;
}
.missing-translation-container > .col{
  height: 100%;
}
.missing-translation-container > .col >.card{
display: flex;
  flex-direction: column;
  height: 100%;
}
.card {
  padding: 1em;
  margin: 0px;
}
.counter{
  margin-top: -10px;
}
.dialog-tree-row {
  list-style-type: none;
  padding-left: 1em;
  overflow: auto;
}
body{
  overflow: hidden;
}
.move-btn:hover {
  cursor: pointer;
}
</style>
